<template>
  <div>
    <router-view />

    <cookie-bar />
  </div>
</template>

<script>
import CookieBar from './components/CookieBar.vue';

export default {
  components: {
    CookieBar,
  },

  methods: {
    width() {
      return document.body.clientWidth;
    },
  },
};
</script>
